import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { LanguagePickerModule } from '../language-picker/language-picker.module';
import { DirectivesModule } from '../../directives/directives.module';

import { LandingHeaderComponent } from './landing-header/landing-header.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';

@NgModule({
  declarations: [HeaderComponent, FooterComponent, LandingHeaderComponent],
  imports: [CommonModule, RouterModule, TranslateModule, LanguagePickerModule, DirectivesModule],
  exports: [HeaderComponent, FooterComponent, LandingHeaderComponent]
})
export class LayoutModule {}
